/*
 * Протокол клиент ↔ сервер.
 *
 * Единственный доменный договор браузера и API. Изменение публичной формы
 * сначала попадает сюда, поэтому несовместимость клиента и сервера ловится
 * компилятором до развёртывания.
 *
 * Проектное решение целиком описано в docs/PROTOCOL.md.
 */
export * from './security.js';
export { readTextEntities, validTextEntities, broadcastText } from './text-entities.js';
/* --- Истории ------------------------------------------------------------ */
/** Сколько живёт история. */
export const STORY_LIFETIME_MS = 24 * 60 * 60 * 1000;
export const DEFAULT_MEMBER_PERMISSIONS = {
    sendMessages: true,
    sendMedia: true,
    addMembers: true,
    pinMessages: false,
    editInfo: false,
    inviteLink: true,
    startCall: true
};
export * from './videos.js';
export * from './dating.js';
export * from './classifieds.js';
export * from './account.js';
export * from './qr.js';
export * from './uploads.js';
export * from './notifications.js';
export * from './calls.js';
export * from './premium.js';
export * from './gifts.js';
export * from './invites.js';
export * from './vpn.js';
export * from './music.js';
//# sourceMappingURL=index.js.map